module.exports = __webpack_public_path__ + "static/media/thestork.3152f7d8.svg";